/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量15
 * @export
 * @interface Col15
 */
export interface Col15 {
}

/**
 * Check if a given object implements the Col15 interface.
 */
export function instanceOfCol15(value: object): value is Col15 {
    return true;
}

export function Col15FromJSON(json: any): Col15 {
    return Col15FromJSONTyped(json, false);
}

export function Col15FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col15 {
    return json;
}

export function Col15ToJSON(json: any): Col15 {
    return Col15ToJSONTyped(json, false);
}

export function Col15ToJSONTyped(value?: Col15 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

